// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateIndiaCity(cityValue: string): ?UserInputValidationError {
  if(!cityValue || cityValue.trim() === '') {
    return {id: 'empty'};
  }

  if(cityValue.length < 3) {
    return { id: 'min-length' };
  }

  if(!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(cityValue)) {
    return { id: 'only-chars-and-space' };
  }

  return undefined;
}
